import styled from 'styled-components';
import { sizes } from 'style';

export const DirectoryContainer = styled.div`
  display: none;
  background-color: rgba(178, 248, 248, 0.1);
  padding: 18px;
  width: 100%;
  border-radius: 32px;
  margin-top: 32px;

  @media ${sizes.mobileLarge} {
    padding: 30px;
  }

  @media ${sizes.tabletPortrait} {
    display: block;
  }
`;
